import { HTTP } from './http';

export const requestQuestions = () => new Promise((resolve, reject) => HTTP.get('/questions')
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestStartingQuestion = () => new Promise((resolve, reject) => HTTP.get('/questions/starting-question')
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestSingleQuestion = (id) => new Promise((resolve, reject) => HTTP.get(`/questions/${id}`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestAppointmentStartingQuestion = () => new Promise((resolve, reject) => HTTP.get('/questions/appointment-starting-question')
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestPreviousQuestion = (id) => new Promise((resolve, reject) => HTTP.get(`/questions/${id}/previous-question`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestNextQuestion = (id) => new Promise((resolve, reject) => HTTP.get(`/questions/${id}/next-question`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));



// WEBPACK FOOTER //
// ./client/api/questions.js